var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandCircleUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "expand_circle_down"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_364_1288",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 17,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 15.9995,
    y: 16,
    width: 16,
    height: 16,
    transform: "rotate(180 15.9995 16)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_364_1288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "expand_circle_down_2",
    d: "M7.99935 5.6665L4.99935 8.6665L5.94935 9.59984L7.99935 7.54984L10.0493 9.59984L10.9993 8.6665L7.99935 5.6665ZM7.99935 1.33317C8.92157 1.33317 9.78824 1.50817 10.5993 1.85817C11.4105 2.20817 12.116 2.68317 12.716 3.28317C13.316 3.88317 13.791 4.58873 14.141 5.39984C14.491 6.21095 14.666 7.07762 14.666 7.99984C14.666 8.92206 14.491 9.78873 14.141 10.5998C13.791 11.4109 13.316 12.1165 12.716 12.7165C12.116 13.3165 11.4105 13.7915 10.5993 14.1415C9.78824 14.4915 8.92157 14.6665 7.99935 14.6665C7.07713 14.6665 6.21046 14.4915 5.39935 14.1415C4.58824 13.7915 3.88268 13.3165 3.28268 12.7165C2.68268 12.1165 2.20768 11.4109 1.85768 10.5998C1.50768 9.78873 1.33268 8.92206 1.33268 7.99984C1.33268 7.07762 1.50768 6.21095 1.85768 5.39984C2.20768 4.58873 2.68268 3.88317 3.28268 3.28317C3.88268 2.68317 4.58824 2.20817 5.39935 1.85817C6.21046 1.50817 7.07713 1.33317 7.99935 1.33317ZM7.99935 2.6665C6.51046 2.6665 5.24935 3.18317 4.21602 4.2165C3.18268 5.24984 2.66602 6.51095 2.66602 7.99984C2.66602 9.48873 3.18268 10.7498 4.21602 11.7832C5.24935 12.8165 6.51046 13.3332 7.99935 13.3332C9.48824 13.3332 10.7493 12.8165 11.7827 11.7832C12.816 10.7498 13.3327 9.48873 13.3327 7.99984C13.3327 6.51095 12.816 5.24984 11.7827 4.2165C10.7493 3.18317 9.48824 2.6665 7.99935 2.6665Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandCircleUp);
export default __webpack_public_path__ + "static/media/expand_circle_up.183d98b846022ab7833f779975aae20d.svg";
export { ForwardRef as ReactComponent };